import React from 'react'
import ReactDOM from 'react-dom'

class StaticTextComponent extends React.Component {

  render() {
    return <div className="form-group" id={this.props.id}>
      {this.props.value}
    </div>
  }
}

export default StaticTextComponent;



// WEBPACK FOOTER //
// ./src/components/common/StaticTextComponent.js